const product = {
  information: "Information", // translated
  additionalInformation: "Weitere Informationen", // translated
  contactUs: "Kontaktiere uns", // translated
  contactUsText: "Möchten Sie Ihre Tour individuell gestalten oder haben Sie weitere Fragen?", // translated
  dropUsAnEmail: "Schreiben Sie uns eine E-Mail", // translated
  viewLess: "Weniger anzeigen", // translated
  viewMore: "Mehr sehen", // translated
  less: "weniger", // translated
  more: "mehr", // translated
  highlights: "Höhepunkte", // translated
  inclusions: "Einschlüsse", // translated
  exclusions: "Ausschlüsse", // translated
  pleaseWait: "Warten Sie mal...", // translated
  tourType: "Tourtyp", // translated
  search: "Suche", // translated
  available: "Erhältlich", // translated
  availableTours: "Verfügbare Touren", // translated
  sortBy: "SORTIEREN NACH", // translated
  priceLowToHigh: "Preis niedrig bis hoch", // translated
  priceHighToLow: "Preis: Hoch bis Niedrig", // translated
  mostPopular: "Am beliebtesten", // translated
  roomOnly: "Nur Zimmer", // translated
  bedAndBreakfast: "Bed & Breakfast", // translated
  halfBoard: "Halbpension", // translated
  fullBoard: "Vollpension", // translated
  allInclusive: "Alles inklusive", // translated
  viewDetails: "Details anzeigen", // translated
  close: "Schließen", // translated
  at: "Beim", // translated
  person: "Person", // translated
  cancellationPolicy: "Stornierungsbedingungen", // translated
  cancellationIs: "Stornierung ist", // translated
  to: "zu", // translated
  bookingRemarks: "Bemerkungen zur Buchung", // translated
  totalPrice: "Gesamtpreis", // translated
  back: "Zurück", // translated
  bookNow: "buchen Sie jetzt", // translated
  minutes: "Protokoll", // translated
  visitDuration: "Besuchsdauer", // translated
  itinerary: "Route", // translated
  airportToHotel: "Flughafen zum Hotel", // translated
  hotelToAirport: "Hotel zum Flughafen", // translated
  details: "Einzelheiten", // translated
  servicesDetails: "Einzelheiten zu den Diensten", // translated
  services: "Dienstleistungen", // translated
  day: "Tag", // translated
  next: "Nächste", // translated
  nextStep: "Nächster Schritt", // translated
  skip: "Überspringen", // translated
  remarks: "Bemerkungen", // translated
  optional: "Optional", // translated
  guests: "Gäste", // translated
  payment: "Zahlung", // translated
  pickup: "aufsammeln", // translated
  featuredPackage: "Vorgestelltes Paket", // translated
  flights: "Flüge", // translated
  accommodation: "Unterkunft", // translated
  transfers: "Überweisungen", // translated
  tours: "Touren", // translated
  experiences: "Erfahrungen", // translated
  featuredTour: "Ausgewählte Tour", // translated
  From: "Aus", // translated
  Accommodation: "Unterkunft", // translated
  approxDuration: "Ca. Dauer", // translated
  travellerInformation: "Informationen für Reisende", // translated
  bookingOverview: "Buchungsübersicht", // translated
  checkout: "Kasse", // translated
  paymentFailed: "Bezahlung fehlgeschlagen", // translated
  paymentSuccess: "Zahlungserfolg", // translated
  night: "Nacht", // translated
  viewEscapes: "Flucht ansehen", // translated
  escapeType: "Fluchttyp", // translated
  adultsOnly: "Nur für Erwachsene", // translated
  totalDuration: "Gesamtdauer", // translated
  options: "Optionen", // translated
  viewExperience: "Erfahrung anzeigen", // translated
  nights: "Nächte", // translated
  childrenAreNotAllowedInThisTour: "Kinder sind bei dieser Tour nicht gestattet", // translated
  products: "Produkte", // translated
  product: "Produkt", // translated
  departingAirport: "Abflughafen", // translated
};

export default product;
